// Typing this string does not create a GetStream mention (only picking from the
// @ menu does), so send-time code must check the text as well. The lookbehind and
// word boundary keep `me@Assembly.com` and `@AssemblyFoo` from counting.
const ASSISTANT_MENTION_PATTERN = /(?<![\w@])@Assembly\b/;

export const textMentionsAssistant = (text: string | undefined) =>
  !!text && ASSISTANT_MENTION_PATTERN.test(text);

// An error or canceled status means the assistant is free to take another request.
export const isAssistantStatusBusy = (status: string | undefined | null) =>
  !!status && status !== 'error' && status !== 'canceled';
